import { Spinner, theme } from '@zappyrent/hundop';
import { rgba } from 'polished';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { StyledWrapper } from './LoadingPage.styles';
import { ILoadingPageProps } from './LoadingPage.types';
import { StyledH2 } from '../../components/UI/Typography';

const LoadingPage = ({ title }: ILoadingPageProps): JSX.Element => {
  const { invitationCode } = useParams();

  useEffect(() => {
    if (invitationCode)
      window.location.replace(
        `https://try.zappyrent.com/landlord/refer_a_friend?invitation_code=${invitationCode}`,
      );
  }, [invitationCode]);

  return (
    <StyledWrapper>
      <StyledH2>{title}</StyledH2>
      <Spinner
        backgroundColor={rgba(theme.colors.landlord.main, 0.2)}
        foregroundColor={theme.colors.landlord.main}
        size={40}
        strokeSize={4}
      />
    </StyledWrapper>
  );
};

export default LoadingPage;
